import { Link } from "react-router-dom";

import { AncetTable, transformAncet } from "@/features/chats";
import { useTrainerChatOutlet } from "./TrainerChatUserLayout";

import styles from "./TrainerChatAncetPage.module.scss";

export const TrainerChatAncetPage = () => {
  const { profile } = useTrainerChatOutlet();

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <Link to=".." className={styles.back}>
          ← Назад к клиенту
        </Link>
        <h3>Анкета клиента</h3>
        <span className={styles.placeholder} />
      </div>

      <AncetTable items={transformAncet(profile.ancet ?? [])} />
    </div>
  );
};









